export function removeSpecialCharacters(str: string) {
    return str.toLocaleLowerCase().replace(/[^\w]+/g, "") || "";
}
